module.exports = __webpack_public_path__ + "static/media/Сафонова Т. (СТО).488e5e2f.pdf";